// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"44957152","374":"6c127c26","434":"33e291cf","533":"6d770aa1","540":"ce46a0c6","590":"a4f74ffe","728":"3bb768ec","871":"84f82702"}[chunkId] + ".chunk.js";
};